// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"UpgradeModal_style_modalWrap__lXcxO","name":"UpgradeModal_style_name__aaSFL","inputName":"UpgradeModal_style_inputName__3kHnI"};